import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { WaProduct } from 'src/api/wa/store/models/product/WaProduct';
import LinkButton from 'src/ui/wards/common/button/LinkButton';
import { FormRow } from 'src/ui/wards/common/form/FormRow';

export type ProductCellProps = {
  product: WaProduct;
  onClick: MouseEventHandler;
};

function ProductCell({ product, onClick }: ProductCellProps) {
  const { t } = useTranslation();

  if (!product) {
    return null;
  }

  return (
    <li className="border-b p-4 py-1">
      <LinkButton title={product.productNumber.toString()} onClick={onClick} />
      <div className="space-y-1 pt-2">
        <FormRow title={t('wards.productList.unit')} className="text-xs">
          {product.unit}
        </FormRow>
        <FormRow title={t('wards.productList.contract')} className="text-xs">
          {product.contractName}
        </FormRow>
        <FormRow title={t('wards.productList.model')} className="text-xs">
          {product.model}
        </FormRow>
      </div>
    </li>
  );
}

export default ProductCell;
